module.exports = __webpack_public_path__ + "img/photo-04.18f23f87.png";